import React from "react";
import Ratings from "./Ratings";

const TestimonialCard = ({ rating, img, name, desc }) => {
  return (
    <div class="flex flex-col bg-lemongray p-3 rounded-xl w-48 drop-shadow-lg shadow-lg">
      <div class="mb-2">
        <Ratings rating={rating} />
      </div>
      <div class="flex flex-row justify-start items-center">
        <img
          src={img}
          alt={name}
          class="w-16 border-2 border-black rounded-xl mr-2"
        />
        <h1 class="font-karla font-bold uppercase">{name}</h1>
      </div>
      <p class="font-karla text-xs mt-2 pr-2">{desc}</p>
    </div>
  );
};

export default TestimonialCard;
